import { sendContactEmail } from './email';

export const submitContactForm = async (data) => {
  try {
    await sendContactEmail(data);
    return { success: true };
  } catch (error) {
    throw new Error('Failed to send message');
  }
}; 